import Layout from "@/layout/index.vue";

export default [
  // 保单管理
  {
    path: "/bdgl",
    name: "bdgl",
    component: Layout,
    redirect: "/dqfcx/fctd",
    meta: {
      title: "业务监管",
    },
    children: [
      {
        path: "/ywjg/fee-for-technical-service-manage",
        name: "feeForTechnicalServiceManage",
        component: () => import("@/views/page/bdgl/technicalServiceManage.vue"),
        meta: {
          title: "技术服务费管理",
          noCache: true
        },
      },
        {
            path: "/dqfcx/fctd",
            name: "fctd",
            component: () => import("@/views/page/bdgl/dqfcx/fctd.vue"),
            meta: {
                title: "短期非车险-非车团单",
                noCache: true
            },
        },
      {
        path: "/dqfcx/fctdPolicyNo/*",
        name: "fctdPolicyNo",
        component: () => import("@/views/page/bdgl/dqfcx/fctdPolicyNo.vue"),
        meta: {
          title: "短期非车险-非车团单",
          noCache: true
        },
      },
        {
            path: "/ywda/ywry",
            name: "ywry",
            component: () => import("@/views/page/bdgl/ywry/ywry"),
            meta: {
                title: "业务人员",
                noCache: true
            },
        },
        {
            path: "/ywda/ywry-detail/*",
            name: "ywryDetail",
            component: () => import("@/views/page/bdgl/ywry/ywryDetail"),
            meta: {
                title: "业务人员",
                noCache: true
            },
        },
    ],
  },
  {
    path: "/ttyb",
    name: "ttyb",
    component: Layout,
    redirect: "/ttyb/fctd",
    meta: {
      title: "天天有保",
    },
    children: [
      {
        path: "/ttyb/fctd",
        name: "ttybfctd",
        component: () => import("@/views/page/ttyb/dqfcx/fctd.vue"),
        meta: {
          title: "短期非车险-非车团单",
          noCache: true
        },
      },
      {
        path: "/ttyb/fctdPolicyNo/*",
        name: "ttybPolicyNo",
        component: () => import("@/views/page/ttyb/dqfcx/fctdPolicyNo.vue"),
        meta: {
          title: "短期非车险-非车团单",
          noCache: true
        },
      },
        {
            path: "/ttyb/ywda/ywry",
            name: "ttybywry",
            component: () => import("@/views/page/ttyb/ywry/ywry"),
            meta: {
                title: "业务人员",
                noCache: true
            },
        },
        {
            path: "/ttyb/ywda/ywry-detail/*",
            name: "ttybywryDetail",
            component: () => import("@/views/page/ttyb/ywry/ywryDetail"),
            meta: {
                title: "业务人员",
                noCache: true
            },
        },
    ],
  },
  // 保司对账
  {
    path: "/reconciliation-bs",
    name: "reconciliationBs",
    component: Layout,
    redirect: "/reconciliation-bs/zx",
    meta: {
      title: "保司对账",
    },
    children: [
      {
        path: "/reconciliation-bs/zx",
        name: "reconciliationBsZx",
        component: () =>
          import("@/views/page/reconciliation-bs/pages/zx/index.vue"),
        meta: {
          title: "赠险对账",
        },
      },
      {
        path: "/reconciliation-bs/ffx-tk",
        name: "reconciliationBsFfxTk",
        component: () =>
          import("@/views/page/reconciliation-bs/pages/ffx-tk/index.vue"),
        meta: {
          title: "付费险对账",
        },
      },
    ],
  },
  // 渠道对账
  {
    path: "/reconciliation-channel",
    name: "reconciliationChannel",
    component: Layout,
    redirect: "/reconciliation-bs/zx",
    meta: {
      title: "渠道对账",
    },
    children: [
      {
        path: "/reconciliation-channel/ffx-lx",
        name: "reconciliationChannelFfxLx",
        component: () =>
          import("@/views/page/reconciliation-channel/pages/ffx-lx/index.vue"),
        meta: {
          title: "零犀对账",
        },
      },
      {
        path: "/reconciliation-channel/luoyang",
        name: "reconciliationChannelLuoyang",
        component: () =>
          import("@/views/page/reconciliation-channel/pages/luoyang/index.vue"),
        meta: {
          title: "洛阳对账",
        },
      },
      {
        path: "/reconciliation-channel/langfang",
        name: "reconciliationChannelLangfang",
        component: () =>
          import(
            "@/views/page/reconciliation-channel/pages/langfang/index.vue"
          ),
        meta: {
          title: "廊坊对账",
          newPage: true,
        },
      },
    ],
  },
  // 自动对账
  {
    path: "/reconciliation-auto",
    name: "reconciliationAuto",
    component: Layout,
    redirect: "/reconciliation-auto/batch-list",
    meta: {
      title: "自动对账",
    },
    children: [
      {
        path: "/reconciliation-auto/batch-list",
        name: "reconciliationAutoBatchList",
        component: () =>
          import("@/views/reconciliation/pages/batch-list/index.vue"),
        meta: {
          title: "收银台对账",
          newPage: true,
        },
      },
        {
            path: "/reconciliation-auto/company-batch-list",
            name: "reconciliationAutoCompanyBatchList",
            component: () =>
                import("@/views/reconciliation/pages/company-batch-list/index.vue"),
            meta: {
                title: "保司对账",
                newPage: true,
            },
        },
    ],
  },
]
